/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as image from "../../common/image";
import * as notification from "./notification";
export { image, notification };
export var AffiliateCRMErrorCode = {
  ImportExceedSingleLimit: 16700001,
  ImportExceedTotalLimit: 16700002,
  ImportCreatorNotExist: 16700003,
  ImportCreatorNotPermThr: 16700004,
  ShopTagExceedTotalLimit: 16700005,
  TagNameSensitiveWord: 16700006,
  CreatorTagBoundExceedLimit: 16700007,
  ShopTagNotExist: 16700008,
  ShopTagAlreadyExist: 16700009,
  ImportTagBoundFail: 16700010,
  CreatorCantDelete: 16700011,
  RegionNotOpenCRM: 16700012,
  ImportShopCreatorFail: 16700013,
  ShopCreatorNotExist: 16700014,
  ImportCreatorListEmpty: 16700015,
  ImportCreatorRegionInvalid: 16700016,
  AccountNotShopPermission: 98001008,
  AccountHasBeenBanned: 16901003
};
export var CRMRangeFilterType = {
  CRMRangeFilterTypeFollowSize: 1,
  CRMRangeFilterTypeGMV: 2
};
export var CRMSingleFilterType = {
  CRMSingleFilterTypeImported: 1,
  CRMSingleFilterTypeWithoutECPermission: 2,
  CRMSingleFilterTypeUninvited: 3,
  CRMSingleFilterTypeAddedFromFindCreators: 4
};
export var CRMMultiFilterType = {
  CRMMultiFilterTypeTag: 1,
  CRMMultiFilterTypeCategory: 2,
  CRMMultiFilterTypeSource: 3
};
export var CRMSortType = {
  CRMSortTypeGMV: 1,
  CRMSortTypeRefundGMV: 2,
  CRMSortTypeItemSold: 3,
  CRMSortTypeRefundItemSold: 4,
  CRMSortTypeProductSold: 5,
  CRMSortTypeVideoNum: 6,
  CRMSortTypeLiveNum: 7
};
export var CRMOrderType = {
  CRMOrderTypeAsc: 1,
  CRMOrderTypeDesc: 2
};
export var CRMCreatorStatus = {
  CRMCreatorStatusNormal: 0,
  CRMCreatorStatusAbnormal: 100,
  CRMCreatorStatusAbnormalHasBranDealInvitation: 101
};
export var TagRange = {
  TagRangeAll: 0,
  TagRangeBoundByAll: 1,
  TagRangeBoundByAny: 2
};
export var CRMCreatorSource = {
  CRMCreatorSourceUnknown: 0,
  CRMCreatorSourceDataWarehouse: 1,
  CRMCreatorSourceImport: 2,
  CRMCreatorSourceFindCreators: 3
};
export var CRMContentType = {
  CRMContentTypeVideo: 1,
  CRMContentTypeLive: 2
};
export var CRMCreatorBatchType = {
  CRMCreatorBatchTypeAll: 1,
  CRMCreatorBatchTypeMultiSelect: 2
};
export var CRMCreatorTaskType = {
  CRMCreatorTaskTypeAddTag: 1,
  CRMCreatorTaskTypeDeleteTag: 2,
  CRMCreatorTaskTypeDeleteCreator: 3
};
export var CRMTaskProgress = {
  CRMTaskProgressOngoing: 1,
  CRMTaskProgressFinished: 2
};
export var CRMCreatorCreateSource = {
  CRMCreatorCreateSourceFindCreators: 1,
  CRMCreatorCreateSourceOpenCollaboration: 2,
  CRMCreatorCreateSourceCreatorDetails: 3
};
export var CRMMaterialScene = {
  CRMMaterialSceneImImage: 1
};
export var CRMMaterialType = {
  CRMMaterialTypeImageUri: 1
};
export var CRMMaterialCheckStatus = {
  CRMMaterialCheckStatusPass: 1,
  CRMMaterialCheckStatusFail: 2
};
export var CRMIMMessageType = {
  CRMIMMessageTypeTextWithImage: 1,
  CRMIMMessageTypeTextWithProducts: 2
};
export var CRMIMRiskMaterial = {
  CRMIMRiskMaterialTitle: 1,
  CRMIMRiskMaterialContent: 2,
  CRMIMRiskMaterialImgUri: 3
};
export var CRMIMProductInvalidCode = {
  CRMIMProductInvalidCodeUnspecified: 0,
  CRMIMProductInvalidCodeInvalidOpenCollaboration: 1,
  CRMIMProductInvalidCodeSellerDeactivate: 2,
  CRMIMProductInvalidCodePlatformDeactivate: 3,
  CRMIMProductInvalidCodeGNEReject: 4,
  CRMIMProductInvalidCodeDelete: 5
};
export var CRMIMFailCode = {
  CRMIMFailCodeUnKnown: 0,
  CRMIMFailCodeCreatorCleared: 1,
  CRMIMFailCodeShopBlock: 2,
  CRMIMFailCodeCreatorBlock: 3,
  CRMIMFailCodeBanned: 4,
  CRMIMFailCodeFollowerLimited: 5,
  CRMIMFailCodeNotAuthorized2NonEUSeller: 6,
  CRMIMFailCodeCreatorBlockByGovernance: 7
};